import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';
import { DataForCustomFormModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { CommissioningRequestDtoModel } from '@bo-client/activation-management/shared/models/commissioningRequestDto';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

type SendOfferForm = FormGroup<{ comment: FormControl<string> }>;

@Component({
  selector: 'app-cr-send-offer-form',
  templateUrl: './cr-send-offer-form.component.html',
  styleUrls: ['./cr-send-offer-form.component.scss']
})
export class CrSendOfferFormComponent
  implements
    CustomFormComponent<
      CommissioningRequestDtoModel,
      {
        additionalData: null;
        comment: string;
      }
    >
{
  @Input() data: DataForCustomFormModel<CommissioningRequestDtoModel>;
  @Output() onConfirm: EventEmitter<{ comment: string; additionalData: null }> = new EventEmitter();

  formGroup: SendOfferForm = inject(FormBuilder).group({
    comment: [null as string]
  });

  cancel() {
    this.onConfirm.emit(null);
  }

  confirm(formGroup: SendOfferForm) {
    if (!formGroup.valid) {
      formGroup.markAllAsTouched();
      return;
    }
    const data = formGroup.getRawValue();
    this.onConfirm.emit({ additionalData: null, comment: data.comment || '' });
  }
}
